module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAAsklEQVQokX2RsQ3CQAxFH4hIiBI6BANkg2yA2IEVKOhYIQMwATtQp6Snp0GipKGkeBQYsKLAl6zzfd//vvOhkmKm7n2hatVQGfDFClgAu9gf6UJyriNfqmWXu/oRNGoRea2Ofwn6wAi4AI9oegquE31gCFwTdwDW/wR3YJq4W6zLX4IHMG9dYwtMgAaoIjZA2Z5/r/XIIv5jo57VXi6WMa0yCd+CRh3lsWbHVRwwula58xPUUO+W6zHFfwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/mounth_white.png
// module id = 735
// module chunks = 0